<ng-container [ngSwitch]="step">
  <db-optimization-progress *ngSwitchCase="'progress'" (onResize)="resize($event)" [userSubscription]="userSubscription" [websiteId]="websiteId"></db-optimization-progress>

  <db-api-unavailable *ngSwitchCase="'apiUnavailable'" (onResize)="resize($event)" (onClose)="close()"></db-api-unavailable>

  <db-plan-not-supported *ngSwitchCase="'planNotSupported'" (onResize)="resize($event)" (onClose)="close()"></db-plan-not-supported>

  <db-optimization-success *ngSwitchCase="'success'" [websiteId]="websiteId" [userSubscription]="userSubscription" [cannotClearCache]="cannotEnableCache"
                           (onResize)="resize($event)" (onBtnClick)="close()"></db-optimization-success>
</ng-container>
